import { useMemo } from 'react';

import { useFeatureClient } from '@ctct/feature-sdk';

type ParamStoreGet<T> = (name: keyof T) => T[keyof T];

export const useParamStore = <T>(name: string) => {
  const { getParameterStore } = useFeatureClient();

  const param = useMemo(() => getParameterStore(name), [getParameterStore, name]);

  return param as Omit<typeof param, 'get'> & { readonly get: ParamStoreGet<T> };
};
